<template>
    <div id="free-term-confirmation">
        <template v-if="$store.patient.has_reservation_permission">
            <div class="section-name-default">Wybrany termin wizyty</div>
            <free-term :free-term="freeTerm" :type="TYPES.CHOSEN"></free-term>
            <div class="note-container">
                <button class="btn-solid-green btn-large btn-confirm" @click="confirmFreeTermWrapper">
                    POTWIERDŹ I ZAREZERWUJ TERMIN
                </button>
            </div>
        </template>
        <div id="no-reservation-permission" v-else>
            <h1 class="warn">Rezerwacja zablokowana!</h1>
            <p class="info"> {{ warnInfo }}</p>
            <button class="btn-outline-blue" @click="goToPatientsPortal">PRZEJDŹ DO SWOJEGO KONTA</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../css/colors.scss";
@import "../../css/constants.scss";

#free-term-confirmation {

    .note-container {
        text-align: right;
        max-width: $free-term-max-width;
        margin: 1em auto;


        label[for=note] {
            color: $blue;
            font-weight: 700;
        }
        #note {
            width: calc(100% - 155px);
        }
        .btn-confirm {
            margin-top: 2em;
            font-weight: 500;
        }
    }
    .free-term {
        margin: auto;
    }
    #no-reservation-permission {
        text-align: center;

        .warn {
            color: $blue;
            font-weight: 400;
        }
        .info {
            font-weight: 300;
            font-size: 16px;
            margin-bottom: 3em;
        }
    }
}
</style>

<script>
import FreeTerm from './FreeTerm.vue'
import ApiMixin from '../mixins/ApiMixin.js'

import {
    ALREADY_RESERVED_TERM_MSG,
    FREE_TERM_TYPES as TYPES,
    NO_PATIENT_VISITS,
    TOO_MUCH_RESERVED_VISITS_MSG,
    PATIENTS_PORTAL_LOGIN_URL,
} from '../constants.js'

export default {
    name: 'FreeTermConfirmation',
    components: {
       FreeTerm,
    },
    mixins: [
        ApiMixin,
    ],
    props: {
        // Free term previously chosen by user.
        freeTerm: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            warnInfo: `Nie można zarezerwować więcej niż ${NO_PATIENT_VISITS} wizyt.`,

            TYPES: TYPES,
        }
    },
    methods: {
        goToPatientsPortal() {
            window.open(PATIENTS_PORTAL_LOGIN_URL);
        },
        confirmFreeTerm(freeTerm, context, inactiveUser=false) {
            const data = {...freeTerm, patient: context.$store.patient.id};
            data.specialty = data.specialty ? data.specialty.id : null;
            const url = context.$api.visit.listReserveFreeTerm();

            context.$app.showLoader();
            return context.$http.post(url, data).then(() => {
                context.$app.loadSelf(() => {
                    context.$app.hideLoader();
                    context.$router.push({name: 'confirmation-response', params: {inactiveUser}});
                });
            }, response => {
                context.$app.hideLoader();
                if (response.status === 400) {
                    if (response.data === ALREADY_RESERVED_TERM_MSG) {
                        if (inactiveUser) {
                            const msg = 'Rejestracja zakończyła się pomyślnie. ' +
                                'Na podanego e-maila została wysłana wiadomość z linkiem aktywacyjnym.';
                            context.$app.showSuccessAlert(msg);
                        }
                        context.$app.showFailureAlert('Wybrany termin został już zajęty.');
                        context.$router.push({name: 'free-terms-list'});
                    }
                    if (response.data === TOO_MUCH_RESERVED_VISITS_MSG) {
                        context.$app.showFailureAlert(this.warnInfo);
                    }
                } else {
                    context.$app.showFailureAlert('Wystąpił nieznany błąd podczas rezerwacji terminu.');
                    context.$router.push({name: 'index'});
                }
            });
        },
        confirmFreeTermWrapper() {
            this.confirmFreeTerm(this.freeTerm, this);
        },
    },
}
</script>



// WEBPACK FOOTER //
// FreeTermConfirmation.vue?1e502996